export const TOOLS = [
  {
    title: "Backend",
    items: ["C#", "Ruby", "Java", ".NET", "Rails"],
  },

  {
    title: "Frontend",
    items: ["JavaScript", "React", "HTML", "CSS", "SCSS/SASS", "Tailwind"],
  },

  {
    title: "Other",
    items: ["Git", "Docker", "Cypress", "Selenium", "Playwright"],
  },
];
